import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { LOGIN_ATTEMPT, LOGIN_RESULT, LOGIN_CHECK, STUDENT_ACCESS_ATTEMPT, STUDENT_ACCESS_RESULT, LOGOUT_ATTEMPT, CHANGE_PLAYER_KEY } from '../Actions/AuthorizationActions'
import { LoginHTTPRequest_API, GET_REQUEST_PARAMETER_API, Routes, GET_REQUEST_DATA_POOL_PARAMETER_API } from '../Services/API'
import { makeid } from '../Services/Utilities'
import { act } from 'react-test-renderer'
import { LOGIN_STATUS_REQUIRED, LOGIN_STATUS_VALID } from '../Reducers/AuthorizationReducer'
import { GET_QUERY_OBJECT_RESULT, GET_QUERY_LIST_RESULT } from '../Actions/LogisticActions'

function* CheckLogin_Saga(action) {
    let token = localStorage.getItem('token')
    let username = localStorage.getItem('username')
    let name = localStorage.getItem('name')
    let roles = localStorage.getItem('roles')
    let isstudent = localStorage.getItem('isstudent') == 'true'
    let student_key = localStorage.getItem('student_key_ABCDEFG') 
    student_key = student_key || (makeid(5)+  Date.now())
    localStorage.setItem('student_key_ABCDEFG', student_key) 

    let data_pool_id = localStorage.getItem('USER_DATA_POOL_ID_HEAT_QUIZ_APP_1567CDFG') ||""
    let data_pool_name = localStorage.getItem('USER_DATA_POOL_NAME_HEAT_QUIZ_APP_1567CDFG') ||""

    console.log("student_key1")
    console.log(student_key)
    console.log("****")

    if(isstudent){
       /* console.log("student_key2")
        console.log(student_key)
        console.log("****")

        yield put({
            type:STUDENT_ACCESS_RESULT,
            token: "",
            username: "student",
            name:'student',
            student: true,
            roles:['student'],
            LoginStatus: LOGIN_STATUS_VALID
        })

        if(!student_key){
            student_key = makeid(5)+  Date.now()
            localStorage.setItem('student_key_ABCDEFG', student_key) 

            console.log("student_key3")
            console.log(student_key)
            console.log("****")

            yield put({
                type:STUDENT_ACCESS_RESULT,
                student_key: student_key
            })
        }

        return*/
    }

    if(token && username){
        yield put({
            type:LOGIN_RESULT,
            token: token,
            username: username,
            name:name,
            roles:roles.split(','),
            student:false,
            student_key: student_key,
            data_pool_id:+data_pool_id,
            data_pool_name:data_pool_name,
            LoginStatus: LOGIN_STATUS_VALID
        })

        if(roles.includes('course_editor')){
            const  Result = yield call(GET_REQUEST_DATA_POOL_PARAMETER_API, Routes.GetAllMyCourses)

            if(Result.Code == 200){
                yield put({
                    type:GET_QUERY_LIST_RESULT,
                    Container:{
                        ['IsMyCoursesSearching']: false,
                        ['MyCourses']: Result.data.data,
                        ['MyCoursesGetError']: ''
                    }
                })
            }
            else{
                yield put({
                    type:GET_QUERY_LIST_RESULT,
                    Container:{
                        ['IsMyCoursesSearching']: false,
                        ['MyCoursesGetError']: Result.message,
                        GeneralError: 'Get My Courses ' + Result.message
                    }
                })
            }

           
        }
    }
    else{
       

        yield put({
            type:STUDENT_ACCESS_RESULT,
            token: "",
            username: "student",
            name:'student',
            student: true,
            roles:['student'],
            LoginStatus: LOGIN_STATUS_VALID,
            student_key: student_key
        })
       /* yield put({
            type:LOGIN_RESULT,
            LoggingError: "Should Login",
            token: null,
            username:null,
            name:null,
            roles:[],
            isstudent:false,
            LoginStatus: LOGIN_STATUS_REQUIRED
        })*/
    }
}


function* Logout_Saga(action) {
    localStorage.setItem('token', null)
    localStorage.setItem('username', null)
    localStorage.setItem('name', null)
    localStorage.setItem('roles', null)
    localStorage.setItem('isstudent', null)

    yield put({
        type:LOGIN_RESULT,
        token: null,
        username: null,
        name:null,
        roles:[],
        student: false,
        LoginStatus: LOGIN_STATUS_REQUIRED
    })
}

function* Login_Saga(action) {
    const  Result = yield call(LoginHTTPRequest_API, action.username, action.password)
    console.log(Result)
    if(Result.Code == 200){
        yield put({
            type:LOGIN_RESULT,
            token: Result.data.data.access_token,
            username: action.username,
            name: Result.data.data.name,
            roles:  Result.data.data.roles,
            student_key: ""
        })

        localStorage.setItem('token', Result.data.data.access_token)
        localStorage.setItem('username', action.username)
        localStorage.setItem('name', Result.data.data.name)
        localStorage.setItem('roles', Result.data.data.roles)

    }
    else{
        yield put({
            type:LOGIN_RESULT,
            LoggingError: Result.message
        })

        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                GeneralError: Result.message
            }
        })
    }
}

function* StudentAccess_Saga(action) {
    localStorage.setItem('isstudent', action.student ? 'true' : 'false')
    localStorage.setItem('username', '')

    let student_key = localStorage.getItem('student_key_ABCDEFG')

    student_key= student_key || (makeid(5)+  Date.now())
    localStorage.setItem('student_key_ABCDEFG', student_key)
    yield put({
        type:STUDENT_ACCESS_RESULT,
        token: "",
        username: "student",
        roles:['student'],
        name:'student',
        student: action.student,
        student_key:student_key,
        LoginStatus: action.student ? LOGIN_STATUS_VALID : LOGIN_STATUS_REQUIRED,
    })
}

export default function* AuthorizationSaga(){
    yield takeLatest(LOGIN_ATTEMPT, Login_Saga)
    yield takeLatest(LOGIN_CHECK, CheckLogin_Saga)
    yield takeLatest(STUDENT_ACCESS_ATTEMPT, StudentAccess_Saga)
    yield takeLatest(LOGOUT_ATTEMPT, Logout_Saga)

}